module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/banner/en-c183185904554fc994d6b6ff04a475a7.jpg";